import * as React from 'react';
import debounce from 'lodash/debounce';

import TranscriptsListWrapper from './TranscriptsListWrapper';
import { EncodingOption, LanguageCodeOption } from './speech';

import NewDocument from './components/NewDocument';
import SearchBar from './components/SearchBar';
import Layout from './components/Layout';

import './Dashboard.css';

const encodings: EncodingOption[] = [
  { text: 'MP3', value: 'MP3' },
  { text: 'WAV', value: 'LINEAR16' },
  { text: 'Greina sjálfvirkt', value: 'GUESS' },
];

type Props = {
  languageCodes: LanguageCodeOption[];
  collectionName?: string;
};

interface State {
  filter: string;
}
class Dashboard extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      filter: '',
    };
  }

  maybeUpdateFilter = debounce((filter: string) => {
    this.setState({ filter: filter.replace(/^ +/, '') });
  }, 500);

  handleFilter = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.maybeUpdateFilter(event.currentTarget.value || '');
  };

  render() {
    const { filter } = this.state;
    return (
      <Layout
        headerComponent={
          <>
            <SearchBar onChange={this.handleFilter} />
          </>
        }
      >
        <div className='dashboard' id='dashboard'>
          <NewDocument encodings={encodings} languageCodes={this.props.languageCodes} />
          <TranscriptsListWrapper filter={filter} collectionName={this.props.collectionName} />
        </div>
      </Layout>
    );
  }
}

export default Dashboard;
